module.exports = __webpack_public_path__ + "279bcd9fee7b2dd786e57d3340465495.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/monsters/monster-3.png
// module id = 1655
// module chunks = 0